module.exports = __webpack_public_path__ + "img/tejesol-logo.fe66b8be.png";